import React, { useEffect, useState } from "react";
import { confirmAlert } from 'react-confirm-alert';
import "./OrderTableDialog.css";
import {
  Box,
  Button,
  Card,
  CardActions,
  CardContent,
  CardMedia,
  Fade,
  Grid,
  Modal,
  Typography,
} from "@mui/material";
import AutoCompleteMultiSelect from "../../../components/AutoCompleteMultiselect/AutoCompleteMultiSelect";
import TextAreaComponents from "../../../components/TextAreaComponents/TextAreaComponents.tsx";
import closeIcon from "./../../../../assets/icons/close.png";
import axios from "axios";
import { toast, ToastContainer } from "react-toastify";
import SweetAlertModal from "./../../../components/SweetAlertModal/SweetAlertModal.js";
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

const styleForOrderCancelationModal = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "70%",
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
};

const OrderTableDialog = (props) => {
  const [openOrderCancelationModal, setOpenOrderCancelationModal] =
    React.useState(props.open);
  const handleCloseOrderCancelationModal = () => {
    props.onclose();
    setOpenOrderCancelationModal(false);
  };
  const [filteredTableDetails, setFilteredTableDetails] = React.useState([]);
  const [tableDetailsCollection, setTableDetailsCollection] = React.useState(
    []
  );
  const restaurant = JSON.parse(localStorage.getItem("restaurant"));
  const [filterText, setFilterText] = React.useState("");
  const [clickedTable, setClickedTable] = useState("");
  const [openConfirmaitonModal, setopenConfirmaitonModal] = useState(false);

  useEffect(() => {
    console.log(restaurant);

    if (restaurant) {
      axios
        .get(
          `${process.env.REACT_APP_SECRET}/api/RestaurantTable/GetAllRestaurantTableInfosByRestaurantId?restaurantId=` +
          restaurant.id
        )
        .then((res) => {
          setFilteredTableDetails(res.data);
          setTableDetailsCollection(res.data);
        })
        .catch((err) => {
          console.warn(err);
        });
    }
  }, []);

  const [selectedTable, setSelectedTable] = useState([]);

  const onHandleSelect = async (selectTableData) => {
    console.log("selectTableData", selectTableData);
    console.log("Sub Order", props.subOrder);

    setSelectedTable({
      subOrderId: props.subOrder.id,
      tableId: selectTableData.tableId,
      tableName: selectTableData.tableName,
    });

    // const obj = {
    //   subOrderId: props.subOrder.id,
    //   tableId: selectTableData.tableId,
    //   tableName: selectTableData.tableName,
    // };
  };

  const handleClose = async () => {
    await axios
      .put(
        `${process.env.REACT_APP_SECRET}/api/Order/UpdateTableForSuborder`,
        selectedTable
      )
      .then((res) => {
        toast.success("Table successfully changed");
        handleCloseOrderCancelationModal();
      })
      .catch((err) => {
        console.warn(err);
        toast.error("Something went wrong");
      });

    setopenConfirmaitonModal(false);
  }

  const submitChangeTable = async () => {
    if (props.subOrder.orderTypeDetails === selectedTable.tableName) {
      toast.info("This table is already selected");
      setopenConfirmaitonModal(false);
      return;
    }

    setopenConfirmaitonModal(true);
  }

  useEffect(() => {
    if (filterText) {
      const filtered = filteredTableDetails.filter((detail) =>
        detail.tableName.toLowerCase().includes(filterText.toLowerCase())
      );
      setFilteredTableDetails(filtered);
    } else {
      setFilteredTableDetails(tableDetailsCollection);
    }
  }, [filterText, filteredTableDetails]);

  return (
    <div>
      <SweetAlertModal
        headerText={"Are you sure?"}
        bodyText={"This action will change the existing table"}
        open={openConfirmaitonModal}
        onyes={handleClose}
        close={() => {
          setopenConfirmaitonModal(false);
        }}
        id={5}
      />

      <ToastContainer />

      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={openOrderCancelationModal}
        onClose={handleCloseOrderCancelationModal}
      >
        <Fade in={openOrderCancelationModal}>
          <Box
            sx={{
              ...styleForOrderCancelationModal,
              maxHeight: "80vh",
              overflowY: "auto",
              position: 'relative',
            }}
          >
            {/* Header */}
            <div className="d-flex justify-content-between">
              <div>
                <h5 style={{ color: "#2a7fd4" }}>GoTaste:- Table Change</h5>
                <h6>{restaurant.name}</h6>
              </div>
              <Button onClick={handleCloseOrderCancelationModal}>
                <img src={closeIcon} style={{ width: "1rem" }} />
              </Button>
            </div>

            <br />
            
            {/* Search Box */}
            <Grid container>
              <Grid xs={12} md={12}>
                <div className="d-flex">
                  <TextAreaComponents
                    id={4}
                    value={(e) => {
                      setFilterText(e);
                    }}
                    label={"Search Table"}
                  />
                </div>
              </Grid>

              <Grid xs={12} md={12} sx={{ marginTop: ".8rem" }}>
                <div
                  className="d-flex"
                  style={{
                    flexWrap: "wrap",
                    gap: "10px",
                    // justifyContent: "center",
                  }}
                >
                  {filteredTableDetails.length > 0 ? (
                    <>
                      {filteredTableDetails.map((dt) => {
                        return (
                          <Card
                            sx={{
                              width: 240,
                              background: props.subOrder.orderTypeDetails === dt.tableName ? 'rgba(224, 224, 224, 0.5)' : '',
                              border: clickedTable === dt.tableName ? '1px solid rgb(0, 128, 0)' : '1px solid rgba(204, 204, 204, 0.66)',
                              cursor: 'pointer',
                              borderRadius: '10px',
                              boxShadow: clickedTable === dt.tableName ? '0px 4px 12px rgba(0, 0, 0, 0.2)' : 'none',
                              transition: 'transform 0.3s ease-in-out',
                              transform: props.subOrder.orderTypeDetails === dt.tableName ? 'scale(1.02)' : 'scale(1)',
                              '&:hover': {
                                transform: 'scale(1.02)',
                              },
                            }}
                            onClick={() => {
                              setClickedTable(dt.tableName);
                              onHandleSelect(dt);
                            }}>
                            <CardMedia
                              sx={{ height: 140 }}
                              image={dt.tableImagePath}
                              title="green iguana"
                            />
                            <CardContent>
                              <Typography
                                gutterBottom
                                variant="h5"
                                component="div"
                                sx={{
                                  fontWeight: props.subOrder.orderTypeDetails === dt.tableName ? 'bold' : 'normal',
                                  fontSize: props.subOrder.orderTypeDetails === dt.tableName ? '1.2rem' : '1rem',
                                }}
                                className="d-flex flex-row align-items-center justify-content-between"
                              >
                                {dt.tableName} 
                                {props.subOrder.orderTypeDetails === dt.tableName && (
                                  <CheckCircleIcon sx={{ color: 'green', marginLeft: '15px', fontSize: '1.2rem' }} />
                                )}
                              </Typography>
                              <Typography
                                variant="body2"
                                sx={{ color: "text.secondary" }}
                              >
                                {dt.description}
                              </Typography>
                            </CardContent>
                          </Card>
                        );
                      })}
                    </>
                  ) : (
                    <span>No Data Found</span>
                  )}
                </div>
              </Grid>
              <Grid
                md={12}
                sx={{
                  display: "flex",
                  justifyContent: "end",
                  gap: "10px",
                  marginTop: "1rem",

                  position: 'sticky',
                  bottom: '0px',
                  left: '500px'
                }}
              >
                <Button
                  variant="outlined"
                  color="success"
                  sx={{ background: 'white' }}
                  onClick={() => {
                    submitChangeTable()
                  }}
                >
                  Okay
                </Button>
                <Button
                  variant="outlined"
                  color="error"
                  sx={{ background: 'white' }}
                  onClick={handleCloseOrderCancelationModal}
                >
                  Close
                </Button>
              </Grid>
            </Grid>
          </Box>
        </Fade>
      </Modal>
    </div>
  );
};

export default OrderTableDialog;
